<template>
  <t-vdxb-default-entry
    sub-heading="Sign up"
    heading="新規お申し込み"
    :navigation-items="navigationItems"
    :class="componentClassName"
  >
    <div v-if="show_form" class="t-vdxb-application-invite-user__instruction">
      <a-vdxb-text>
        お申し込みには下記の書類が必要です。<br />
        ご準備いただき、規約に同意した上でお手続きを進めてください。
      </a-vdxb-text>

      <!-- New SignUp -->
      <div class="t-vdxb-application-invite-user__box t-vdxb-application-invite-user__box--individual">
        <h3 class="t-vdxb-application-invite-user__box-title">
          <a-vdxb-icon icon="user" />
          個人名義でお申し込みの場合
        </h3>
        <ul class="t-vdxb-application-invite-user__box-list">
          <li class="t-vdxb-application-invite-user__box-item">運転免許証、またはマイナンバーカード</li>
        </ul>
      </div>

      <div class="t-vdxb-application-invite-user__box t-vdxb-application-invite-user__box--coporation">
        <h3 class="t-vdxb-application-invite-user__box-title">
          <a-vdxb-icon icon="building" />
          法人名義でお申し込みの場合
        </h3>
        <ul class="t-vdxb-application-invite-user__box-list">
          <li class="t-vdxb-application-invite-user__box-item">
            登記事項証明書（登記簿謄本）
            <div class="t-vdxb-application-invite-user__box-detail">
              <p>以下の項目を確認します。</p>
              <ul>
                <li>① 法人の名称</li>
                <li>② 本店または主たる事務所の所在地</li>
                <li>③ 事業内容</li>
                <li>④ 実質的支配者の有無</li>
                <li>⑤ 実質的支配者の氏名・住所・生年月日・顧客との関係</li>
              </ul>
              <div class="t-vdxb-application-invite-user__remark">
                <a-vdxb-caption-list>
                  <li>
                    実質的支配者については
                    <a-vdxb-button
                      id="ownerLink"
                      variant="text"
                      color="primary"
                      target="_blank"
                      :href="authFailUrl"
                      title="別ウインドウにてPDF文書が表示されます。"
                      >こちら(99KB)</a-vdxb-button
                    ><img src="/public/PDF_32.png" class="t-vdxb-application-invite-user__icon-margin" />
                  </li>
                </a-vdxb-caption-list>
              </div>
            </div>
          </li>
          <li class="t-vdxb-application-invite-user__box-item">お申し込み者様の運転免許証、またはマイナンバーカード</li>
          <li class="t-vdxb-application-invite-user__box-item">
            <!--  eslint-disable-next-line prettier/prettier -->
            委任状（<a-vdxb-button id="powerOfAttorneyLink" variant="text" color="primary" target="_blank" :href="authFailUrl2" title="別ウインドウにてPDF文書が表示されます。">様式例を確認(99KB)</a-vdxb-button
            ><img src="/public/PDF_32.png" />）
            <div class="t-vdxb-application-invite-user__box-detail">
              <div class="t-vdxb-application-invite-user__remark">
                <a-vdxb-caption-list>
                  <li>お申し込み者様が会社役員の場合は不要です。</li>
                </a-vdxb-caption-list>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <form class="t-vdxb-application-invite-user__form" @submit.prevent="handleSubmitForm">
      <m-form-input label="サービス利用約款">
        <a-vdxb-checkbox id="serviceUsageCheck" v-model="formData.service_usage" :disabled="!serviceUsageView">
          <a-vdxb-button
            id="serviceUsageLink"
            variant="text"
            color="primary"
            target="_blank"
            underline
            :href="serviceUsageUrl"
            title="別ウインドウにてPDF文書が表示されます。"
            @click="serviceUsageView = true"
          >
            サービス利用約款(853KB)</a-vdxb-button
          ><img src="/public/PDF_32.png" class="t-vdxb-application-invite-user__icon-margin" />
          に同意する
        </a-vdxb-checkbox>
      </m-form-input>

      <m-form-input label="重要事項説明">
        <a-vdxb-checkbox id="importantMatterCheck" v-model="formData.important_matter" :disabled="!importantMatterView">
          <a-vdxb-button
            id="importantMatterLink"
            variant="text"
            color="primary"
            target="_blank"
            underline
            :href="importantMatterUrl"
            title="別ウインドウにてPDF文書が表示されます。"
            @click="importantMatterView = true"
          >
            重要事項説明(476KB)</a-vdxb-button
          ><img src="/public/PDF_32.png" class="t-vdxb-application-invite-user__icon-margin" />
          に同意する
        </a-vdxb-checkbox>
      </m-form-input>

      <m-form-input label="プライバシーポリシー">
        <a-vdxb-checkbox id="privacyPolicyCheck" v-model="formData.privacy_policy" :disabled="!privacyPolicyView">
          <a-vdxb-button
            id="privacyPolicyLink"
            variant="text"
            color="primary"
            target="_blank"
            underline
            :href="privacyPolicyUrl"
            title="別ウインドウにて表示されます。"
            @click="privacyPolicyView = true"
          >
            プライバシーポリシー</a-vdxb-button
          >
          に同意する
        </a-vdxb-checkbox>
      </m-form-input>

      <m-form-input label="犯罪収益移転防止法にもとづく取引時の確認">
        <a-vdxb-checkbox id="transactionTimeCheck" v-model="formData.transaction_time" :disabled="!transactionTimeView">
          <a-vdxb-button
            id="transactionTimeLink"
            variant="text"
            color="primary"
            target="_blank"
            underline
            :href="transactionTimeUrl"
            @click="transactionTimeView = true"
          >
            犯罪収益移転防止法にもとづく取引時の確認(99KB)</a-vdxb-button
          ><img src="/public/PDF_32.png" class="t-vdxb-application-invite-user__icon-margin" />
          を承諾し、必要書類を提出する
        </a-vdxb-checkbox>
      </m-form-input>

      <m-form-input label="通話時の音声録音">
        <a-vdxb-checkbox id="voiceRecordCheck" v-model="formData.voice_record">
          本サービスご利用時のすべての音声通話が録音されることについて同意する
        </a-vdxb-checkbox>
      </m-form-input>

      <br />
      <a-vdxb-caption-list
        ><li>
          サービス利用約款、重要事項説明、プライバシーポリシー、犯罪収益移転防止法にもとづく取引時の確認については、リンクを開いてお読みいただくと、チェックができます。
        </li></a-vdxb-caption-list
      >
      <a-vdxb-caption-list
        ><li>上のチェックをすべて入れていただくとお申し込みボタンが押せるようになります。</li></a-vdxb-caption-list
      >

      <m-button-container class="t-vdxb-application-invite-user__buttons">
        <a-vdxb-button
          id="individual"
          variant="block"
          color="primary"
          :disabled="
            !(
              formData.service_usage &&
              formData.important_matter &&
              formData.privacy_policy &&
              formData.transaction_time &&
              formData.voice_record
            )
          "
          @click="showModal('individual')"
        >
          個人名義のお申し込み
        </a-vdxb-button>
        <a-vdxb-button
          id="company"
          variant="block"
          color="primary"
          :disabled="
            !(
              formData.service_usage &&
              formData.important_matter &&
              formData.privacy_policy &&
              formData.transaction_time &&
              formData.voice_record
            )
          "
          @click="showModal('company')"
        >
          法人名義のお申し込み
        </a-vdxb-button>
      </m-button-container>
      <teleport to="body">
        <o-vdxb-modal
          v-model:visible="showModalDialog"
          class="o-vdxb-modal-vdxb-application-invite-user"
          footer-variant="confirmation"
          width="442px"
          :footer-shadow="true"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          :show-close="false"
        >
          <template #title>必要書類の確認</template>
          <div class="t-vdxb-application-invite-user__box-detail">
            <p>必要書類は準備しましたか？ よろしければ申し込みにお進みください。</p>
            <div class="t-vdxb-application-invite-user__box t-vdxb-application-invite-user__box--individual">
              <h3 class="t-vdxb-application-invite-user__box-title">
                <a-vdxb-icon icon="user" />
                個人名義でお申し込みの場合
              </h3>
              <ul class="t-vdxb-application-invite-user__box-list">
                <li class="t-vdxb-application-invite-user__box-item">運転免許証、またはマイナンバーカード</li>
              </ul>
            </div>
            <div class="t-vdxb-application-invite-user__box t-vdxb-application-invite-user__box--coporation">
              <h3 class="t-vdxb-application-invite-user__box-title">
                <a-vdxb-icon icon="building" />
                法人名義でお申し込みの場合
              </h3>
              <ul class="t-vdxb-application-invite-user__box-list">
                <li class="t-vdxb-application-invite-user__box-item">登記事項証明書 (登記簿謄本）</li>
                <li class="t-vdxb-application-invite-user__box-item">
                  お申し込み者様の運転免許証、またはマイナンバーカード
                </li>
                <li class="t-vdxb-application-invite-user__box-item">委任状 (お申し込み者様が会社役員の場合は不要）</li>
              </ul>
            </div>
          </div>

          <!-- eslint-enable -->
          <template #footer>
            <a-vdxb-button
              id="back"
              variant="outlined"
              color="primary"
              label="戻る"
              size="small"
              @click="showModalDialog = false"
            />
            <a-vdxb-button
              id="next"
              variant="block"
              color="primary"
              submit="submit"
              label="申し込みに進む"
              size="small"
              @click="handleSubmitForm"
            />
          </template>
        </o-vdxb-modal>
      </teleport>
    </form>

    <teleport to="body">
      <o-vdxb-modal
        v-model:visible="resultModalVisible"
        class="o-vdxb-modal-remove-phone-number-confirmation"
        footer-variant="confirmation"
        width="442px"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <template #title>{{ resultModalTitle }}</template>
        <a-vdxb-text>
          <!-- eslint-disable -->
          <span v-html="resultModalContent" />
          <!-- eslint-enable -->
        </a-vdxb-text>
        <template #footer>
          <a-vdxb-button id="ok" variant="block" color="primary" label="OK" size="small" @click="handleCloseModal" />
        </template>
      </o-vdxb-modal>
    </teleport>
  </t-vdxb-default-entry>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import TVdxbDefaultEntry from '@/components/templates/vdxb-default-entry';
import AVdxbIcon from '@/components/atoms/vdxb-icon';
import AVdxbButton from '@/components/atoms/vdxb-button';
import AVdxbText from '@/components/atoms/vdxb-text';
import AVdxbCaptionList from '@/components/atoms/vdxb-caption-list';
import MButtonContainer from '@/components/molecules/button-container';
import OVdxbModal from '@/components/organisms/vdxb-modal';
import { messageContent } from '@/common/messageContent.js';
import { customRequest } from '@/common/customRequest.js';

import { utils } from '@/common/utils.js';

export default {
  name: 't-vdxb-application-invite-user',
  components: {
    TVdxbDefaultEntry,
    AVdxbIcon,
    AVdxbButton,
    AVdxbText,
    AVdxbCaptionList,
    MButtonContainer,
    OVdxbModal,
  },
  mixins: [messageContent, customRequest],
  props: {
    class: {
      type: String,
      default: '',
    },
    // authFailUrl: {
    //   type: String,
    //   default: '#',
    // },
    priceList: {
      type: Array,
      default: new Array(0),
    },
    individualList: {
      type: Array,
      default: new Array(0),
    },
    coporationList: {
      type: Array,
      default: new Array(0),
    },
    // terms: {
    //   type: String,
    //   default: '',
    // },
    navigationItems: {
      type: Array,
      default: new Array(0),
    },
    handleProceedClick: {
      type: Function,
      default: () => {},
    },
    // handleCancelClick: {
    //   type: Function,
    //   default: () => {},
    // },
  },
  data() {
    return {
      // 約款等のチェック用フラグ
      formData: {
        service_usage: false,
        important_matter: false,
        privacy_policy: false,
        transaction_time: false,
        voice_record: false,
      },

      // 約款等URL
      serviceUsageUrl: 'https://www.ntt.com/content/dam/nttcom/hq/jp/about-us/disclosure/tariff/pdf/c297.pdf',
      importantMatterUrl:
        'https://www.ntt.com/content/dam/nttcom/hq/jp/business/services/application/ai/cotoha-vdxb/pdf/voicedxbasic_jyusetsu.pdf',
      privacyPolicyUrl: 'https://www.ntt.com/about-us/hp/privacy.html',
      transactionTimeUrl:
        'https://www.ntt.com/content/dam/nttcom/hq/jp/business/services/application/ai/cotoha-vdxb/pdf/voicedxbasic_hansyuho.pdf',

      // 約款等リンクの既読チェック
      serviceUsageView: false,
      importantMatterView: false,
      privacyPolicyView: false,
      transactionTimeView: false,

      showModalDialog: false,
      authFailUrl:
        'https://www.ntt.com/content/dam/nttcom/hq/jp/business/services/application/ai/cotoha-vdxb/pdf/voicedxbasic_hansyuho.pdf',
      authFailUrl2:
        'https://www.ntt.com/content/dam/nttcom/hq/jp/business/services/application/ai/cotoha-vdxb/pdf/voicedxbasic_hansyuho.pdf',
      campaignUrl: '/public/campaign.pdf#toolbar=0',
      resultModalVisible: false,
      resultModalTitle: '',
      resultModalContent: '',
      businessType: '',
      show_form: false,
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-vdxb-application-invite-user');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  mounted() {
    this.show_form = true;
    utils.setMetaDescription(this.$route);
    document.title = '新規お申し込み | COTOHA Voice DX Basic';
  },
  methods: {
    handleSubmitForm(e) {
      e.preventDefault();
      this.postRequest('/signup/createtmpdata', { voicedxOnlyFlag: true })
        .then(async e => {
          if (e.session) {
            if (e.status === 'failed') {
              this.showErrorModal(messageContent.requireTry('新規お申し込み'));
            } else {
              await this.setCookie('tmpUUID', e.tmpUUID, 'tmpYMD', e.tmpYMD);

              const tmpData = {
                businessType: this.businessType,
              };

              this.postRequest('/signup/updateBusinessType', {
                tmpCompanyID: e.tmpUUID,
                tmpYMD: e.tmpYMD,
                validate: false,
                data: tmpData,
              })
                .then(e => {
                  if (e.session) {
                    if (e.status === 'failed') {
                      this.showErrorModal(messageContent.requireTry('新規お申し込み'));
                    } else {
                      this.$router.push({ path: '/vdxbsignup/form' });
                    }
                  } else {
                    window.location.href = '/login';
                  }
                })
                .catch(err => {
                  console.log(err);
                  this.showErrorModal(messageContent.requireTry('新規お申し込み'));
                });
            }
          } else {
            window.location.href = '/login';
          }
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('新規お申し込み'));
        });
    },
    setCookie: async function (key, value, key2, value2) {
      await this.postRequest('/signup/setCookie', { key: key, value: value, key2: key2, value2: value2 })
        .then(e => {
          if (e.session) {
            if (e.status === 'failed') {
              this.showErrorModal(messageContent.requireTry('新規お申し込み'));
            }
          } else {
            window.location.href = '/';
          }
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('新規お申し込み'));
        });
    },
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showModal(type) {
      this.businessType = type;
      this.showModalDialog = true;
    },
  },
};
</script>
